import { expectObject } from '@datagrok-libraries/utils/src/test';
export function expectMonomerLib(lib, summary) {
    const exp = summary;
    const act = lib.getSummaryObj();
    for (const pt in exp)
        if (!exp[pt])
            delete exp[pt];
    for (const pt in act)
        if (!act[pt])
            delete act[pt];
    if (Object.keys(exp).length == 0 && Object.keys(act).length != 0)
        throw new Error('Expected empty monomer lib, actual is not.');
    else if (Object.keys(exp).length != 0 && Object.keys(act).length == 0)
        throw new Error('Expected non-empty monomer lib, actual is empty.');
    else {
        try {
            expectObject(act, exp);
            expectObject(exp, act);
        }
        catch (err) {
            throw new Error(`Expected monomer lib ${JSON.stringify(exp)} does not match actual ${JSON.stringify(act)}.`);
        }
    }
}
//# sourceMappingURL=monomer-lib-tests.js.map